import { FC } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useEquityMarketAdminPanel } from '../contexts/EquityMarketAdminPanelContext';

import EquityMarketAdminPanelHeader from '../components/EquityMarketAdminPanelHeader';
import EquityMarketAdminPanelSummaryCard from '../components/EquityMarketAdminPanelSummaryCard';
import EquityMarketAdminPanelOffersList from '../components/EquityMarketAdminPanelOffersList';

const EquityMarketAdminPanel: FC = () => {
  const { data, actions } = useEquityMarketAdminPanel();

  return (
    <Page id="equity-market-admin-panel-page">
      <EquityMarketAdminPanelHeader
        societyId={data.societyId}
        societyName={data.societyName}
      />

      <EquityMarketAdminPanelSummaryCard
        sellOffersSummary={data.sellOffersSummary}
        buyOffersSummary={data.buyOffersSummary}
        pendingOperationsCount={data.pendingOperationsCount}
      />

      <div className="nk-block">
        <EquityMarketAdminPanelOffersList
          sellOffers={data.sellOffers}
          buyOffers={data.buyOffers}
          operations={data.operations}
          onViewOfferDetail={actions.handleViewOfferDetail}
          onViewOperationDetail={actions.handleViewOperationDetail}
          onUpdateOperationStatus={actions.handleUpdateOperationStatus}
        />
      </div>

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default EquityMarketAdminPanel;
